//SPIN DESIGN Custom JS
/*sidebar menu*/
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.menu-list-below-filters .accordion-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const parentItem = this.closest('.accordion-item');
      const sublist = parentItem.querySelector('.accordion-sublist');

      if (!sublist) return;

      if (parentItem.classList.contains('active')) {
        // Collapse this sublist
        sublist.style.height = sublist.scrollHeight + "px"; // set current height
        requestAnimationFrame(() => {
          sublist.style.height = "0px";
        });
        parentItem.classList.remove('active');
      } else {
        // Expand this sublist
        parentItem.classList.add('active');
        sublist.style.height = "0px"; // reset height
        requestAnimationFrame(() => {
          sublist.style.height = sublist.scrollHeight + "px";
        });

        // Remove inline height after transition for flexibility
        sublist.addEventListener('transitionend', function removeHeight() {
          if (parentItem.classList.contains('active')) {
            sublist.style.height = "auto";
          }
          sublist.removeEventListener('transitionend', removeHeight);
        });
      }
    });
  });
});


//ATL
  document.addEventListener('DOMContentLoaded', function() {
    
    // Block checkout if ATL not selected (capture phase = runs before Shopify's handlers)
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
      if (!btn) return;
      
      const atlChoice = document.querySelector('input[name="attributes[Authority To Leave]"]:checked');
      
      if (!atlChoice) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        alert('Please select an Authority To Leave option to continue.');
        
        const atlSection = document.querySelector('.cart-drawer__atl, .cart__atl');
        if (atlSection) atlSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        
        return false;
      }
    }, true); // capture phase - critical
    
    
    // Visual: disable button until choice is made
    function toggleCheckoutButtons() {
      const atlChoice = document.querySelector('input[name="attributes[Authority To Leave]"]:checked');
      const buttons = document.querySelectorAll('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
      
      buttons.forEach(btn => {
        if (!atlChoice) {
          btn.setAttribute('disabled', 'disabled');
          btn.style.opacity = '0.5';
          btn.style.cursor = 'not-allowed';
        } else {
          btn.removeAttribute('disabled');
          btn.style.opacity = '';
          btn.style.cursor = '';
        }
      });
    }
    
    // Initial check
    toggleCheckoutButtons();
    
    // Listen for radio changes (delegated - survives drawer re-render)
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[name="attributes[Authority To Leave]"]')) {
        toggleCheckoutButtons();
        
        // Also save the choice to cart immediately
        const instructions = document.querySelector('#CartDrawer-ATLInstructions, #ATLInstructions');
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Authority To Leave': e.target.value,
              'Delivery Instructions': instructions ? instructions.value : ''
            }
          })
        });
      }
    });
    
    // Re-check when drawer re-renders (Dawn dispatches these events)
    document.addEventListener('cart:refresh', toggleCheckoutButtons);
    
    // Fallback: watch DOM for drawer updates
    const observer = new MutationObserver(function(mutations) {
      for (const m of mutations) {
        if (m.addedNodes.length) {
          toggleCheckoutButtons();
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
  });
